import s from './style.module.scss';
import emtyImg from '@/assets/images/mobile/empty.webp';
const Error = (props) => {
    return (
        <div className={s['error-box']}>
            <img className={s['error-img']} src={props.img || emtyImg} alt="" />
            <div className={s['error-text']}>{props.text || '暂无数据哦~'}</div>
            <div className={s['error-action']}>{props.action}</div>
        </div>
    );
};

export default Error;
